// extracted by mini-css-extract-plugin
module.exports = {"main":"PageContent_main__j8LLJ","newMain":"PageContent_newMain___l_nf"};